import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MemberNotificationService } from '../../../shareModule/services/member-notification.service';
import { QUEST_STATUS } from 'src/app/admin/super-admin/quests/quests.component';
import { ViewProductDetailsComponent } from '../view-product-details/view-product-details.component';
import { AllNotificationsModalComponent } from './all-notifications-modal.component';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
export interface Notification {
  id: number | string;
  title: string;
  type: string;
  header: string;
  message: string;
  createDate: string;
  status: string;
  payload: Object | string;
  isRead: boolean
}

@Component({
  selector: 'notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit, OnDestroy {
  public data: {
    title: string;
    description: string;
    type: string;
    payload: Object;
    id: string | number;
  } = { title: '', description: '', payload: {}, type: '', id: '' };

  notificationPopup: boolean = false;
  @ViewChild('clickSound') clickSound: any;
  @ViewChild('kachiingSound') kachiingSound: any;
  timeoutId: any;

  @ViewChild('ViewProductDetailsComponent')
  viewProductDetailsComponent: ViewProductDetailsComponent;
  @Input() type: string = null;
  public selectedNotification: any;
  public notificationList: Array<Notification> = [];
  public status = QUEST_STATUS;
  public modalRef: any = null;
  public currentNotificationForMobile = null;

  showingAll = false;

  openMenuForMobile:boolean= false;
  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth < 767;
  }
  onDropdownOpen(isOpen) {
    if (isOpen) {
      // this.allNotifications.forEach((notif: any) => {
      //   this.auth.updateNotificationIsRead(notif.id).subscribe(() => { });
      // });
      
      this._memberNotificationService.getNotification();
    } else {
      this.makeAllNotifsSeen()
      
    }
  }
  private makeAllNotifsSeen(){
    this.auth.makeAllNotificationsOfUserSeen().subscribe({error: console.error, next: ()=>this._memberNotificationService.getNotification()});
    this.notificationList = this.allNotifications.filter((i: any) => {
      if (typeof i.payload != 'object') i.payload = JSON.parse(i.payload);

      return i?.quest?.status != 4 && !i.isRead;
    });
  }

  showRecentNotifications() {
    this.showingAll = false;
    this.notificationList = this.allNotifications.filter((i: any) => {
      if (typeof i.payload != 'object') i.payload = JSON.parse(i.payload);

      return i?.quest?.status != 4 && !i.isRead;
    });
    
    this.cdr.detectChanges();
  }
  showAllNotifications() {
    this.notificationList = this.allNotifications.filter((i: any) => {
      if (typeof i.payload != 'object') i.payload = JSON.parse(i.payload);

      return i?.quest?.status != 4;
    });
    this.showingAll = true;
    this.cdr.detectChanges();
  }

  allNotifications: Notification[] = [];
  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private _memberNotificationService: MemberNotificationService,
    private sharedService: SharedService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this._memberNotificationService.notificationList.subscribe(
      (resp: Array<Notification>) => {
       // console.trace('notifying user', )
        this.notificationList = resp.filter((i: any) => {
          if (typeof i.payload != 'object') i.payload = JSON.parse(i.payload);

          return i?.quest?.status != 4 && !i.isRead;
        });
        this.allNotifications = resp.filter((i: any) => {
          if (typeof i.payload != 'object') i.payload = JSON.parse(i.payload);

          return i?.quest?.status != 4;
        });
        this.cdr.detectChanges();

        const unSeenFirstNotif = this.notificationList.find((notif) => !notif.isRead) 
        if (unSeenFirstNotif) {
          this.notifyUser(
            unSeenFirstNotif
          );
        }
      }
    );
  }
  ngOnDestroy(): void {
    this.makeAllNotifsSeen();
  }

  ngOnInit(): void {
    this._memberNotificationService.$notify.subscribe(
      (resp: any) => {
        this.notifyUser(resp);
      }
    );
  }

  public popupClick() {
    if (this.data.type == 'chat-notif') {
      this.sharedService.triggerChatNow({
        chatingNow: this.data.payload['responseChatId'],
        menu: 'chat',
        chatTitle: null, //the component will get it
      });
    }

    console.log(this.data, "NOTIFICATION")
    if (this.data.type == 'giveaway') {
      this.router.navigate(['/giveaway'], { queryParams: { uuid: this.data.payload['uuid'] } })
    }
    this.notificationPopup = false;
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
    if (this.data.id) {
      this._memberNotificationService.clearNotificationById(this.data.id);
    }
  }

  public notifyUser(
    notif
  ): void {
    //console.trace("notify user called #eb", notif)
    this.data = notif;
   
    this.notificationPopup = !this.notificationPopup;
    if(this.isMobile){
      this.currentNotificationForMobile = notif
      this.openMenuForMobile = true;
      this.cdr.detectChanges()
      this.setParentZIndex();
     
      
      setTimeout(()=>{
        //this.auth.updateNotificationIsRead(id as number).subscribe({error: console.error})
        this.openMenuForMobile = false
        
        this.currentNotificationForMobile = null
       
        this.cdr.detectChanges()
        this.clearParentZIndex();
     
      }, 5500)
     
   


    }
  
    if (notif.type=='coin'){ 
      this.kachiingSound.nativeElement.play();
    }
    else if(this.notificationPopup){
      this.clickSound.nativeElement.play()
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId); // Clear the previous timeout
    }

    
  

    if (this.notificationPopup) {
      this.timeoutId = setTimeout(() => {
        this.notificationPopup = false;
        this.timeoutId = null; // Reset the timeout ID
      }, 5000);
    }
  }

  public openNotification(modal: any, selectedData) {
    this.selectedNotification = selectedData;
    console.log("this.selected", selectedData)
    if (this.selectedNotification.type == 'quest') {
      this.modalRef = this.modalService.open(modal, {
        size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'suggestion',
      });
    } else if (this.selectedNotification.type == 'chat-notif') {
      this.sharedService.triggerChatNow({
        chatingNow: this.selectedNotification.payload['responseChatId'],
        menu: 'chat',
        chatTitle: null, //the component will get it
      });
    } else if (this.selectedNotification.type == 'giveaway') {
      console.log(this.selectedNotification.title.includes('Winner'))
      this.router.navigate(['/giveaway'], {
        queryParams: {
          uuid: this.selectedNotification.payload['uuid'],
          winner: this.selectedNotification.title.includes('Winner')
        }
      })
    }
  }
  public setParentZIndex(){
    const el = document.getElementsByClassName('nav-top-mobile')[0] as HTMLElement;
    if(el){
      el.style.zIndex = '2000';
    }
  }
  public clearParentZIndex(){
    const el = document.getElementsByClassName('nav-top-mobile')[0] as HTMLElement;
    el.style.zIndex = '1001';
  }

  public accept(status: number) {
    this.auth
      .updateQuestStatus(this.selectedNotification?.id, status)
      .subscribe((response: ApiResponse) => {
        this.toastr.success('Quest Accepted!');
        this.modalRef.close();
        this._memberNotificationService.getNotification();
      });
  }

  public closeNotification(selected: any) {
    this.auth
      .updateNotificationIsRead(selected.id)
      .subscribe((response: ApiResponse) => {
        this._memberNotificationService.getNotification();
      });
    
  }
}
